import * as React from 'react'
import Alert from '@mui/material/Alert'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import { CustomField } from '@user/components/Opportunities/SoldServicesDrawer/SoldServicesContent/AdditionalInfo/CustomField'
import { SalesNoteField } from '@user/components/Opportunities/SoldServicesDrawer/SoldServicesContent/AdditionalInfo/SalesNoteField'
import { BulkCloseWinEditProps } from './typings'
import { RowErrors } from './RowErrors'
import { useValidateRows } from './hooks/useValidateRows'
import Box from '@mui/material/Box'
import { Theme } from '@mui/material/styles'

export function FormFields(props: BulkCloseWinEditProps) {
  const { readonly, appDataState, validateRows } = props
  const validationResults = useValidateRows(validateRows)

  return (
    <>
      {appDataState.status === 'pending' && (
        <Box
          sx={{
            paddingTop: (theme: Theme) => theme.spacing(4.8),
            textAlign: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {appDataState.status === 'fail' && (
        <Alert severity="error">Failed to load Custom Fields.</Alert>
      )}

      {appDataState.status === 'success' && (
        <div>
          <Typography style={{ fontFamily: 'Source Sans Pro SemiBold' }}>
            Technicians / Sales People
          </Typography>

          {readonly == true && (
            <Alert severity="info">
              You have selected opportunities to close/win from multiple
              branches. Change your selection to opportunities from a single
              branch to select technicians/staff.
            </Alert>
          )}

          {appDataState.appData.map((a) => (
            <CustomField key={a.id} appData={a} disabled={readonly} />
          ))}

          <SalesNoteField {...props} disabled={false} />

          <RowErrors {...validationResults} />
        </div>
      )}
    </>
  )
}
